<template>
   <dashboard-layout><v-container fluid class="down-top-padding py-0">
      <BaseBreadcrumb :title="page.title" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
      <v-row dense class="mb-3"><v-col cols="12" sm="6" md="3" v-for="card in summaries" :key="card.label"><v-card outlined :style="`border-left:4px solid ${card.hex}`"><v-card-text class="d-flex align-center"><v-avatar :color="card.color" size="44" class="mr-3"><v-icon dark>{{ card.icon }}</v-icon></v-avatar><div><div class="text-h5 font-weight-bold">{{ card.value }}</div><div class="caption">{{ card.label }}</div></div></v-card-text></v-card></v-col></v-row>
      <v-card><v-toolbar dark color="primary"><v-icon left>mdi-account-arrow-up</v-icon><v-toolbar-title>Corporate Upgrade Applications</v-toolbar-title><v-spacer></v-spacer><v-text-field v-model="search" append-icon="mdi-magnify" label="Search applicant" single-line hide-details dark style="max-width:280px"></v-text-field></v-toolbar>
         <v-alert v-if="flash.status" type="success" dense text class="ma-4 mb-0">{{ flash.status }}</v-alert>
         <v-alert v-if="flash.error" type="error" dense text class="ma-4 mb-0">{{ flash.error }}</v-alert>
         <v-data-table :headers="headers" :items="applications" :search="search" :items-per-page="10">
            <template v-slot:[`item.applicant`]="{ item }">
               <div class="py-2">
                  <strong>{{ item.fullname }}</strong>
                  <div class="caption">{{ item.memberid || 'No Member ID' }} · Previous: {{ item.applcorp_previous_membertype || 'GRA' }}</div>
                  <div class="caption grey--text">{{ item.contactemail }}</div>
               </div>
            </template>
            <template v-slot:[`item.applcorpstatus`]="{ item }">
               <v-chip small dark :color="statusColor(item)">{{ statusLabel(item) }}</v-chip>
            </template>
            <template v-slot:[`item.dateapplied`]="{ item }">{{ formatDate(item.dateapplied) }}</template>
            <template v-slot:[`item.schedule`]="{ item }">
               <div class="caption">
                  <strong>Course:</strong> {{ formatDateOnly(item.applcorp_course_date) }}<br>
                  <strong>Interview:</strong> {{ formatDateOnly(item.applcorp_interview_date) }}<br>
                  <strong>Exam:</strong> {{ formatDateOnly(item.applcorp_exam_date) }}
               </div>
            </template>
            <template v-slot:[`item.endorsement`]="{ item }">
               <div class="py-1">
                  <div class="caption grey--text">Proposer</div>
                  <v-chip x-small dark :color="endorsementColor(item.applcorp_proposer_status)">{{ endorsementLabel(item.applcorp_proposer_status) }}</v-chip>
                  <div class="caption grey--text mt-1">Seconder</div>
                  <v-chip x-small dark :color="endorsementColor(item.applcorp_seconder_status)">{{ endorsementLabel(item.applcorp_seconder_status) }}</v-chip>
               </div>
            </template>
            <template v-slot:[`item.document`]="{ item }">
               <v-btn v-if="item.applcorp_document" text x-small color="primary" :href="documentUrl(item)" target="_blank"><v-icon left x-small>mdi-file-document-outline</v-icon>View</v-btn>
               <div class="caption notes">{{ item.applcorp_notes || '-' }}</div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
               <div class="d-flex flex-wrap py-2 actions">
                  <v-btn x-small color="primary" dark class="mr-1 mb-1" :href="`/admin/member/upgrade-corporate/${item.userid}`"><v-icon left x-small>mdi-open-in-new</v-icon>Open Info</v-btn>
                  <v-btn v-if="parseInt(item.applcorpstatus)===1&&bothEndorsed(item)" x-small color="success" dark class="mr-1 mb-1" @click="approve(item)">Approve</v-btn>
                  <v-btn v-if="parseInt(item.applcorpstatus)===1&&!bothEndorsed(item)" x-small color="success" dark class="mr-1 mb-1" disabled title="Waiting for proposer & seconder">Approve</v-btn>
                  <v-btn v-if="[1,4].includes(parseInt(item.applcorpstatus))" x-small color="warning" dark class="mr-1 mb-1" @click="incomplete(item)">Incomplete</v-btn>
                  <v-btn v-if="[1,2,4].includes(parseInt(item.applcorpstatus))" x-small color="error" dark class="mb-1" @click="reject(item)">{{ parseInt(item.applcorpstatus)===2?'Management Reject':'Reject' }}</v-btn>
               </div>
            </template>
            <template v-slot:no-data><div class="pa-8 text-center grey--text"><v-icon size="48" color="grey lighten-1">mdi-account-arrow-up</v-icon><div>No Corporate Upgrade applications found.</div></div></template>
         </v-data-table>
      </v-card>
   </v-container></dashboard-layout>
</template>
<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'; import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
export default {
   name: 'MOACorporateUpgrades',
   components: { DashboardLayout, BaseBreadcrumb },
   props: { applications: { type: Array, default: () => [] } },
   data: () => ({
      page: { title: 'Corporate Upgrade Applications' },
      breadcrumbs: [{ text: 'Dashboard', disabled: false, to: '/dashboard' }, { text: 'Corporate Applications', disabled: true }],
      search: '',
      headers: [
         { text: 'Applicant', value: 'applicant' },
         { text: 'Status', value: 'applcorpstatus' },
         { text: 'Applied', value: 'dateapplied' },
         { text: 'Schedule', value: 'schedule', sortable: false },
         { text: 'Endorsement', value: 'endorsement', sortable: false },
         { text: 'Notes / Document', value: 'document', sortable: false },
         { text: 'Actions', value: 'actions', sortable: false },
      ],
   }),
   computed: {
      flash() { return (this.$page && (this.$page.props || this.$page).flash) || {} },
      summaries() {
         const c = s => this.applications.filter(x => parseInt(x.applcorpstatus) === s).length
         return [
            { label: 'Pending Review', value: c(1), color: 'orange darken-2', hex: '#ef6c00', icon: 'mdi-clock-outline' },
            { label: 'Need Resubmission', value: c(4), color: 'deep-purple', hex: '#673ab7', icon: 'mdi-reload-alert' },
            { label: 'Approved', value: c(2), color: 'green', hex: '#2e7d32', icon: 'mdi-check-circle-outline' },
            { label: 'Rejected', value: c(3), color: 'red', hex: '#c62828', icon: 'mdi-close-circle-outline' },
         ]
      },
   },
   methods: {
      statusLabel(item) { 
         const v = parseInt(item.applcorpstatus)
         if (v === 2 && parseInt(item.memberstatus) !== 3) return 'Pending Payment'
         return ({ 1: 'Pending Review', 2: 'Approved', 3: 'Rejected', 4: 'Need Resubmission' })[v] || 'Unknown'
      },
      statusColor(item) { 
         const v = parseInt(item.applcorpstatus)
         if (v === 2 && parseInt(item.memberstatus) !== 3) return 'blue darken-1'
         return ({ 1: 'orange darken-2', 2: 'green', 3: 'red', 4: 'deep-purple' })[v] || 'grey'
      },
      endorsementLabel(v) { return ({ 0: 'Pending', 1: 'Approved', 2: 'Rejected' })[parseInt(v || 0)] || 'Pending' },
      endorsementColor(v) { return ({ 0: 'orange darken-2', 1: 'green', 2: 'red' })[parseInt(v || 0)] || 'orange darken-2' },
      bothEndorsed(item) { return parseInt(item.applcorp_proposer_status || 0) === 1 && parseInt(item.applcorp_seconder_status || 0) === 1 },
      formatDate(v) { return v ? new Date(v).toLocaleString('en-MY') : '-' },
      formatDateOnly(v) { return v ? new Date(v).toLocaleDateString('en-MY') : '-' },
      documentUrl(i) { return `/${i.applcorp_documentpath}/${i.applcorp_document}` },
      approve(i) { if (confirm(`Approve Corporate Upgrade for ${i.fullname}?`)) this.$inertia.post('/admin/member/upgrade-corporate/approve', { userid: i.userid }, { preserveScroll: true }) },
      incomplete(i) { if (confirm(`Mark ${i.fullname}'s application incomplete?`)) this.$inertia.post('/admin/member/email/incomplete', { userid: i.userid }, { preserveScroll: true }) },
      reject(i) { if (confirm(`Reject Corporate Upgrade for ${i.fullname}?`)) this.$inertia.post('/admin/member/upgrade-corporate/reject', { userid: i.userid }, { preserveScroll: true }) },
   },
}
</script>
<style scoped>.actions{min-width:290px}.notes{max-width:210px;white-space:normal}</style>